import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nSharedConfig } from 'utils/shared/utils';
import { i18nConfig as i18nUiConfig } from 'utils/ui';
import { enUS, he } from 'date-fns/locale';
import { format } from 'date-fns';

export const dateFormat = (
  date: Date | string | undefined | number,
  formatStr: string,
  locale?: string
) => {
  const lang = locale || localStorage.getItem('language');
  const dateObj = date == null ? new Date() : date instanceof Date ? date : new Date(date);

  return format(dateObj, formatStr, { locale: lang === 'en' ? enUS : he });
};

export interface i18nDynConfigProps {
  enTranslation: any;
  heTranslation: any;
  esTranslation: any;
}

export const i18nDynConfig = (props: i18nDynConfigProps) => {
  const lang = localStorage.getItem('language');

  i18nSharedConfig({ ...props, ruTranslation: {} });
  i18nUiConfig(props);

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: props.enTranslation,
      },
      he: {
        translation: props.heTranslation,
      },
      es: {
        translation: props.esTranslation,
      },
    },
    lng: lang ? lang : 'he',
    fallbackLng: 'he',

    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
